import { defineComponent as e, createElementBlock as a, openBlock as o, normalizeClass as t } from "vue";
const s = /* @__PURE__ */ e({
  name: "RevDivider",
  __name: "Divider",
  props: {
    variant: { default: "horizontal" }
  },
  setup(n) {
    return (r, l) => (o(), a("hr", {
      class: t(["border-static-default-low", {
        "border-l-1 border-t-0": r.variant === "vertical",
        "border-t": r.variant === "horizontal"
      }])
    }, null, 2));
  }
});
export {
  s as default
};
